
import BbCheckbox from '../Checkbox/Checkbox.vue';
import { includesValidator } from '../../common/utils/validator';

const selectListSize = {
  ExtraLarge: 'extra-large',
  Large: 'large',
  Small: 'small',
  ExtraSmall: 'mini',
};

export default {
  name: 'BbSelectListItem',
  components: { BbCheckbox },
  props: {
    icon: String,
    iconStyle: String,
    value: {
      type: [Object, String, Number],
      default: '',
      required: true,
    },
    label: [String, Number],
    created: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: selectListSize.Large,
      validator: includesValidator(selectListSize),
    },
  },
  data() {
    return {
      selected: false,
    };
  },
  computed: {
    attrs() {
      return {
        value: this.value,
        label: this.label,
        created: this.created,
        disabled: this.disabled,
      };
    },
  },
  methods: {
    checkIsSelected() {
      this.selected = this.$refs.selectListItem?.$el.classList.contains('selected') || false;
    },
  },
  mounted() {
    this.checkIsSelected();
  },
};
